import {useEffect, useState} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {HeaderWrapper} from './components/header'
import {RightToolbar} from '../partials/layout/RightToolbar'
import {ScrollTop} from './components/scroll-top'
import {Content} from './components/content'
import {FooterWrapper} from './components/footer'
import {Sidebar} from './components/sidebar'
import {
  DrawerMessenger,
  ActivityDrawer,
  InviteUsers,
  UpgradePlan,
  ThemeModeProvider,
} from '../partials'
import {PageDataProvider} from './core'
import {reInitMenu} from '../helpers'
import {ToolbarWrapper} from './components/toolbar'
import { SideBarBaixo } from './components/sidebar/sidebar-baixo'
import { NotificationDrawer } from '../partials/layout/notification-drawer'
import { useAuth } from '../../app/modules/auth'
import { LoadingSpan } from '../../app/pages/components/Loadings/loadingSpan'
import { Link } from 'react-router-dom'
import { isDashboardHomePath } from '../../app/utils/homePath'

const MasterLayout = () => {
  const location = useLocation()
  const [largura, setLargura] = useState(window.innerWidth);
  const [searchNotificationsDrawer, setSearchNotificationsDrawer] = useState(false);
  const {auth, currentUser, authStatus, verifyAuth} = useAuth();

  useEffect(() => {
    verifyAuth()
  }, [currentUser, verifyAuth])

  const atualizarTamanhoDaTela = () => {
    setLargura(window.innerWidth);
  };

  useEffect(() => {
    reInitMenu()
  }, [location.key])

  useEffect(() => {
    window.addEventListener('resize', atualizarTamanhoDaTela);
    return () => {
      window.removeEventListener('resize', atualizarTamanhoDaTela);
    };
  }, [])

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
          <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
            <HeaderWrapper lag={largura} searchNotificationsDrawer={searchNotificationsDrawer}/>
            
            {auth?.api_token && !currentUser && largura > 1200 && (
              <div className={`alert rounded-0 mb-0 text-center ${authStatus === 'session_expired' ? 'alert-danger' : 'alert-warning'}`}>
                {authStatus === 'session_expired' ? (
                  <>
                    Sua sessão expirou.{' '}
                    <Link to='/auth/login' className='fw-bold text-danger-emphasis'>
                      Faça login novamente
                    </Link>
                    .
                  </>
                ) : (
                  <>
                    Servidor indisponível no momento. Tentando reconectar... <LoadingSpan />
                  </>
                )}
              </div>
            )}
            
            <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
              <Sidebar />
              <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
                <div className='d-flex flex-column flex-column-fluid' 
                  
                  style={
                    largura < 1200 
                    ? isDashboardHomePath(location.pathname) ? {marginTop: '5rem'} :  {marginTop: '9rem'}
                    : {marginTop: ''}}
                  >
                  <ToolbarWrapper />
                  <Content>
                    <Outlet />
                  </Content>
                </div>
                {largura > 1200 && <FooterWrapper />}
                {/* <SideBarBaixo /> */}
                {largura < 1200 ? <SideBarBaixo /> : <></>}
              </div>
            </div>
          </div>
        </div>

        {/* begin:: Drawers */}
        {largura < 1200 && (
        <NotificationDrawer 
          setSearchNotificationsDrawer={setSearchNotificationsDrawer}
        />
        )}
        <ActivityDrawer />
        <RightToolbar />
        <DrawerMessenger />
        {/* end:: Drawers */}

        {/* begin:: Modals */}
        <InviteUsers />
        <UpgradePlan />
        {/* end:: Modals */}
        <ScrollTop />
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

export {MasterLayout}
